import PropTypes from "prop-types";
import { Link } from "react-router-dom";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

function MDLink({ href, children, color, target, rel, ...rest }) {
  const isExternal = href?.startsWith("http") || href?.startsWith("www") || target === "_blank";

  const linkStyles = {
    textDecoration: "none",
    color: color || "info",
    cursor: "pointer",
    transition: "color 0.15s ease-in-out",
    "&:hover": {
      color: color === "primary" ? "#1A73E8" : "#1A73E8",
      textDecoration: "underline",
    },
  };

  if (isExternal) {
    return (
      <MDBox
        component="a"
        href={href}
        target={target || "_blank"}
        rel={rel || "noopener noreferrer"}
        sx={linkStyles}
        {...rest}
      >
        {children}
      </MDBox>
    );
  }

  return (
    <MDBox component={Link} to={href} sx={linkStyles} {...rest}>
      {children}
    </MDBox>
  );
}

// Typechecking props for the MDLink
MDLink.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
    "white",
  ]),
  target: PropTypes.string,
  rel: PropTypes.string,
};

export default MDLink; 